import React, { useState } from "react";
import generateHexShade from "../Utilities/generateHexShade";
import { leadGenButtonStyle } from "../Utilities/customClassTypes";

interface FormButtonProps {
  backgroundColor: string;
  textColor: string;
  text: string;
  disabled: boolean;
}

const FormButton = ({
  backgroundColor,
  textColor,
  text,
  disabled,
}: FormButtonProps): JSX.Element => {
  const [isHover, setIsHover] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(false);

  const hoverBtnColor = generateHexShade(backgroundColor, -10);
  const activeBtnColor = generateHexShade(backgroundColor, -20);

  const handleBtnColorState = () => {
    if (isActive) {
      return activeBtnColor;
    }
    if (isHover) {
      return hoverBtnColor;
    }
    return backgroundColor;
  };

  const inlineBtnStyles = {
    background: handleBtnColorState(),
    color: isActive || isHover ? "#ffffff" : textColor,
  };

  return (
    <button
      disabled={disabled}
      type="submit"
      className={leadGenButtonStyle}
      style={inlineBtnStyles}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => {
        setIsHover(false);
        setIsActive(false);
      }}
      onMouseDown={() => setIsActive(true)}
      onMouseUp={() => setIsActive(false)}
    >
      {text}
    </button>
  );
};

export default FormButton;
